import { ReferenceInputProps, InputProps, ReferenceInput, SelectInput } from "react-admin"

interface Props extends Omit<InputProps, "source"> {
  source?: string
  category_id?: string
}

const ProductRefInput = (
  props: Props & Omit<Omit<ReferenceInputProps, "source">, "reference" | "children">,
) => (
  <ReferenceInput
    source={props.source ?? "product_id"}
    reference="products"
    filter={props.category_id ? { category_id: props.category_id } : {}}
  >
    <SelectInput
      fullWidth={props.fullWidth}
      optionText={(item) =>
        `${item.title ?? ""} ${item.product_code ? `(${item.product_code})` : ""}`
      }
      {...props}
    />
  </ReferenceInput>
)

ProductRefInput.defaultProps = {
  source: "product_id",
  addLabel: true,
}

export { ProductRefInput }
